import { render, staticRenderFns } from "./detailsSalesVolumeNew.vue?vue&type=template&id=dba77112&scoped=true&"
import script from "./detailsSalesVolumeNew.vue?vue&type=script&lang=js&"
export * from "./detailsSalesVolumeNew.vue?vue&type=script&lang=js&"
import style0 from "./detailsSalesVolumeNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailsSalesVolumeNew.vue?vue&type=style&index=1&id=dba77112&lang=scss&scoped=true&"
import style2 from "./detailsSalesVolumeNew.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba77112",
  null
  
)

component.options.__file = "detailsSalesVolumeNew.vue"
export default component.exports